import * as React from 'react';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import { BrowserRouter, Routes, Route, useNavigate, Navigate, useLocation, Outlet, useParams, } from 'react-router-dom';
import Home from './modules/home';
import { Provider, useSelector } from 'react-redux';
import store from './redux/index';
import Signup from './modules/signup';
import Login from './modules/login';
import PlansLogin from './modules/plansLogin';
import ForgotPassword from './modules/forgot_password';
import PasswordChange from './modules/password_change';
import OtpVerify from './modules/otp_verify';
import Profile from './modules/profile';
import Product from './modules/products';
import AddProducts from './modules/addProducts';
// import { Inventory } from '@mui/icons-material';
import Inventory from './modules/Inventory';
import Orders from './modules/orders';
import ProductDetails from './modules/productDetails';
import OrdersStatus from './modules/order_status';
import Dashboard from './modules/dashboard';
import { jwtDecode } from 'jwt-decode';
import { useState,useEffect } from 'react'
import { Router } from '@mui/icons-material';
import Invoice from './components/invoice';
import Settings from './modules/admin_settings/adminsettings';
import { StaticWebPage } from './staticPageComponents/staticPage';

import CulturePage from './staticPageComponents/culturepage';
import { FinancialSystem } from './staticPageComponents/financialSystem';
import RefundPolicy from './staticPageComponents/refund_policy';
import PrivacyPolicy from './staticPageComponents/privacy_policy';
import TermsOfService from './staticPageComponents/terms_services';
import ShippingPolicy from './staticPageComponents/shipping_policy';
import { LandingPage } from './landing_page/landing_page';
import CommisionHistory from './modules/commision_history';
import { MyWallet } from './modules/my_wallet';
import WithdrawView from './modules/withdrawAdminView';
import  OtpSignPin  from './components/otp_verify_signup';
import Stocklist from './modules/stocklist';
import Stockbatch from './modules/stockbatch';
import InventryOverview from './modules/inventryOverview'; 
import CampaingMsgBlast from './components/campaignMsgBlast';
import NotificationSettings from './modules/admin_settings/notificationSettings';
import NotFoundPage from './staticPageComponents/404';
// import { AyushChat } from './components/AyushChat';
import PackageConfig from "./modules/packageConfiguration"
import CurrencyConversion from "./components/CurrencyConversion"
import PaymentPage from "./modules/paymepage"
import BundleProducts_ORL from './modules/bundleProducts';
import BundleProductDetails from './modules/bundleProductDetails';
import { updateMembership } from './redux/user_reducer';
import { useDispatch } from 'react-redux';
import  ChatBot from './components/chatBot';
import GlobalOrders from './modules/globalOrders';
import PoolAndShareConcepts from './modules/poolAndShareConcepts';
import PaymentProcessing from './modules/paymentProcessing';
import { Box, CircularProgress } from '@mui/material';
export const ColorModeContext = React.createContext({ toggleColorMode: () => { } });
// import { useLocation } from 'react-router-dom';

// const authToken=localStorage.getItem("authToken")
// const Authorize = () => {
//   const location = useLocation()
//   // console.log(authToken,role)
//   if(!authToken || role ){
//     return <Navigate to="/login"/>
//   }
//   return <Outlet/>
// }

const CheckProductDetails = ({pages,path})=>{
  const products = useSelector(state=>state.product.Allproducts)
  const params = useParams()
  // console.log(Object.keys(params)[0],pages,pages.includes('/'+path.split('/')[1]+'/:'+Object.keys(params)[0]))
  if(Object.keys(products).length === 0 && !isNaN(params.id)&& !pages.includes('/'+path.split('/')[1]+'/:'+Object.keys(params)[0])){
   
      return <Navigate to='/product'/>
    }else if (!pages.includes('/'+path.split('/')[1]+'/:'+Object.keys(params)[0])){
 return <NotFoundPage/>
    }
  
  return <Outlet/>
}

const CheckBundleDetails = ({pages,path})=>{
  const bundles = useSelector(state=>state.bundles.bundles)
  const params = useParams()
 
  // console.log("---------From App.js--------",pages,'/'+path.split('/')[1]+'/:'+Object.keys(params)[0],!pages.includes('/'+path.split('/')[1]+'/:'+Object.keys(params)[0]))

  if(!pages.includes('/'+path.split('/')[1]+'/:'+Object.keys(params)[0])){
    // console.log("-----inside if---------")
    if(bundles?.length === 0 ){
      return <Navigate to='/product'/>
    }
    return <Outlet/>
  }
  else if (pages && pages?.length >=1 && !pages.includes('/'+path.split('/')[1]+'/:'+Object.keys(params)[0])){
    return <NotFoundPage/>
  }
  return <Outlet/>
}


const CheckOrderDetails = ({pages,path})=>{
  const orders = useSelector(state=>state.orders.AllOrders)
  const params = useParams()
  // console.log(params,orders.length,pages.includes('/'+path.split('/')[1]+'/:'+Object.keys(params)[0]))
  if(Object.keys(orders).length === 0 &&!pages.includes('/'+path.split('/')[1]+'/:'+Object.keys(params)[0])){
   
    return <Navigate to='/orders'/>
   
  }
  else if (!pages.includes('/'+path.split('/')[1]+'/:'+Object.keys(params)[0])){
    return <NotFoundPage/>
  }
  return <Outlet/>
}

const CheckPasswordChange = ({authToken,refreshToken})=>{
  const {id} = useParams()
  if(id === "change" && authToken && refreshToken){
    return <PasswordChange/>
  }
  else if(id === "forgot" && authToken && refreshToken){
    return <PasswordChange/>
  }
  return <NotFoundPage/>

}
const StockBatchDetails = ({pages,path})=>{
  const stock = useSelector(state=>state.admin.inventoryHistory)
  const params = useParams()
  // console.log(params,stock.length,pages.includes('/'+path.split('/')[1]+'/:'+Object.keys(params)[0]))
  if(Object.keys(stock).length === 0 &&!pages.includes('/'+path.split('/')[1]+'/:'+Object.keys(params)[0])){
   
    return <Navigate to='/stocklist'/>
   
  }
  else if (!pages.includes('/'+path.split('/')[1]+'/:'+Object.keys(params)[0])){
    return <NotFoundPage/>
  }
  return <Outlet/>
}

const CheckGlobalOrderDetails = ({pages,path})=>{
  const params = useParams()
  const pathPattern = '/global-orders/:orderId'
  // Check if user has access to global-orders detail route
  if (!pages.includes(pathPattern)){
    return <NotFoundPage/>
  }
  return <Outlet/>
}


function MyApp() {
  const authToken=localStorage.getItem('authtoken');
  const res= authToken && jwtDecode(authToken)
  const refreshToken=localStorage.getItem('refreshToken');
  let  username = useSelector(state => state.user.username)
  const email = useSelector(state => state.user.email )
  const mobileno = useSelector(state => state.user.mobile_no )
  const role = useSelector(state => state.user?.role)
  const member=useSelector(state=>state.user.member)
  const allAccess=useSelector(state=>state.user.accessControl)
  const location=useLocation()
  const control=useSelector(state=>state.user.control)
  let dispatch=useDispatch()
  const userres=useSelector(state=>state.user.member_response)
    const accessControl=useSelector(state=>state.user.accessControl)
    let [pages,setPages]=useState([])
    let [module,setModule]=useState([])
    const [admin,setAdmin]=useState(false)
    const [accessResolved, setAccessResolved] = useState(!authToken)
  useEffect(()=>{
      if (authToken){
          const decode=jwtDecode(authToken)
          let access=allAccess.filter(item=>item.role==decode.control)[0]
          // console.log("???????????????????????????",access,location.pathname)
          dispatch(updateMembership(decode.member))

          let pathname=location.pathname
          if(decode.role=='admin'){
            setAdmin(true)
            // console.log("???????????????????????????access control",decode.control)
                      }
      }
     
  },[role])
  useEffect(()=>{
// console.log("??????????????????authtoken",authToken)
   if (!authToken){
    setAccessResolved(true)
    return
   }
   if (authToken){
    const decode=jwtDecode(authToken)
    const access=accessControl.filter(item=>item.role==decode.control)[0]
    // console.log("????????????????????access",authToken)
    // decode.control
        // console.log(access.access)
    let module=[]
    let pages=[]
        access?.access?.map(item=>{
            // console.log(item,typeof(item))
        if(typeof(item)=='object' ){
           module.push(Object.keys(item)[0])
           pages=[...pages,...Object.values(item)[0]]
        }
        else if(typeof(item)=='string' ){
            pages.push(item)

        }
    })
    setPages(pages)
    setModule(module)
    setAccessResolved(true)
    // CheckAccess(pages,location.pathname)
    // if (!pages.includes(location.pathname)){

    //   return <NotFoundPage/>
    // }
   }
      
},[control,authToken,role])
  // const navigate = useNavigate();
  // console.log("access based on user control",location.pathname,pages)
  if (authToken && refreshToken && res?.role === "admin" && !accessResolved){
    return (
      <Box sx={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", bgcolor:"#fff" }}>
        <CircularProgress />
      </Box>
    )
  }
  return (
    
      <Routes>
        <Route path="/payment-processing" element={<PaymentProcessing />} />
        <Route exact path="/products" element={<Home />} />
        {/* <Route path="/plans" element={<PlansLogin/>} /> */}
        <Route path="/signup" element={<Signup/>} />
        <Route path='/login' element={<Login/>}/>
        {/* <Route path="/otp-verify-signup" element={<OtpSignPin/>} /> */}
        <Route path="/forgot-password" element={<ForgotPassword/>} />
        {/* <Route path="/culture" element={<CulturePage/>} /> */}

      
        <Route path="/otp-verification" element={ <OtpVerify />}/>
        
        {/* </Route> */}
        {/* <Route path="/invoice" element={<Invoice/>}></Route> */}
        <Route
          path="/"
          element={
            role !== "mkt" && role != "admin"
              ? <Navigate to="/products" />
              : role != "admin"
                ? <CampaingMsgBlast/>
                : <Navigate to={pages.includes("/dashboard") ? "/dashboard" : pages.includes("/product") ? "/product" : pages.includes("/orders") ? "/orders" : "/profile"} />
          }
        ></Route>
        <Route path="/Financial_system" element={<FinancialSystem/> }></Route>
        <Route path="/refund-policy" element={<RefundPolicy/> }></Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy/> }></Route>
        <Route path="/terms-service" element={<TermsOfService/> }></Route>
        <Route path="/shipping-policy" element={<ShippingPolicy/> }></Route>
        <Route path="/password-change/:id" element={<CheckPasswordChange authToken={authToken} refreshToken={refreshToken}/>} />
        <Route path="/product_details/:id" element={ <ProductDetails /> } />
        <Route path="/bundle_details/:id" element={ <BundleProductDetails /> } />
        {/* Legacy checkout/cart flow disabled for video-subscription-only testing */}
        {/* <Route path="/checkout" element={<Checkout /> }/> */}
        <Route path="/payment-page" element={<PaymentPage /> }/>
        {/* <Route path="/ayushcare" element={<AyushChat/>}></Route> */}
        {/*--------------------------- User Routes ---------------------- */}
        {authToken && (res.role === "user"|| res.role=='sc') && refreshToken &&
          <>
            <Route path="/profile" element={ <Profile/>  }/>
            {/* <Route path="/orderstatus" element={<OrdersStatus /> }/> */}
            {/* <Route path="/checkout" element={userres?.account?.referred_by_id ==68 ? <NotFoundPage/> :<Checkout /> }/> */}
            <Route path="/my_networth" element={member=='member'? <MyWallet/>:<NotFoundPage/> }></Route>
            <Route path="/dashboard" element={member=='member'?  <Dashboard />:<NotFoundPage/>  }/>
          </>
        }
        {/*--------------------------- Admin Routes---------------------- */}
        {
          authToken && res.role === "admin" && refreshToken &&
          <>
            <Route path="/profile" element={!pages.includes(location.pathname)?<NotFoundPage/>:<Profile/>  }/>
            <Route path="/product" element={ !pages.includes(location.pathname)?<NotFoundPage/>: <Product />  }/>

            <Route element={<CheckProductDetails pages={pages} path={location.pathname} />}>
              <Route path="/product/:id" element={  <AddProducts /> } />
            </Route>
            <Route path="/dashboard" element={pages.includes(location.pathname)?  <Dashboard />:<NotFoundPage/>  }/>
            <Route path="/my_networth" element={pages.includes(location.pathname)? <MyWallet/>:<NotFoundPage/> }></Route>
            <Route path="/orders" element={!pages.includes(location.pathname)?<NotFoundPage/>:  <Orders /> }/>

            <Route path="/pool_share_concepts" element={!pages.includes(location.pathname)?<NotFoundPage/>:  <PoolAndShareConcepts /> }/>

            <Route element={<CheckBundleDetails  pages={pages} path={location.pathname}  />}>
              <Route path="/bundle/:id" element={ <BundleProducts_ORL /> }/>
            </Route>


            <Route element={<CheckOrderDetails pages={pages} path={location.pathname} />}>
              <Route path="/orders/:orderId" element={  <Orders /> }/>
            </Route>

            {/* <Route path="/global-orders" element={!pages.includes(location.pathname)?<NotFoundPage/>:  <GlobalOrders /> }/> */}
            {/* <Route element={<CheckGlobalOrderDetails pages={pages} path={location.pathname} />}>
              <Route path="/global-orders/:orderId" element={<GlobalOrders /> }/>
            </Route> */}

            <Route path="/inventry" element={!pages.includes(location.pathname)?<NotFoundPage/>:   <Inventory /> }/>
            <Route path="/inventry_overview" element={ !pages.includes(location.pathname)?<NotFoundPage/>:   <InventryOverview />  }/>
            <Route path="/stocklist" element={!pages.includes(location.pathname)?<NotFoundPage/>:  <Stocklist /> }/>
            <Route element={<StockBatchDetails pages={pages} path={location.pathname} />}>
            <Route path="/stocklist/:id" element={<Stockbatch /> }/>
            </Route>

            <Route path="/commision-history" element={ !pages.includes(location.pathname)?<NotFoundPage/>: <CommisionHistory />  }/>
            {/* <Route path="/Withdraw-request" element={ !pages.includes(location.pathname)?<NotFoundPage/>: <WithdrawView />  }/> */}
            <Route path="/delivery-settings" element={!pages.includes(location.pathname)?<NotFoundPage/>:  <Settings/> }></Route>
            <Route path="/notification-settings" element={ !pages.includes(location.pathname)?<NotFoundPage/>:<NotificationSettings/>}/>
            <Route path="/package_config" element={!pages.includes(location.pathname)?<NotFoundPage/>: <PackageConfig/>}/>
            <Route path="/currency-conversion" element={!pages.includes(location.pathname)?<NotFoundPage/>: <CurrencyConversion/>}/>

          </>
        }
        <Route path="*" element={<NotFoundPage/>} />
      </Routes>
    // </BrowserRouter>

  );
}

export default function ToggleColorMode() {
  const [mode, setMode] = React.useState('light');
  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [],
  );

  const theme = React.useMemo(
    () =>
      createTheme({"palette":{"common":{"black":"rgba(36, 36, 36, 1)","white":"#fff"},"background":{"paper":"#fff","default":"#fff"},"primary":{"light":"#00C2FF","main":"#00C2FF","dark":"rgba(0, 113, 197, 1)","contrastText":"rgba(255, 255, 255, 1)"},"secondary":{"light":"rgba(103, 251, 168, 1)","main":"rgba(3, 218, 101, 1)","dark":"rgba(2, 159, 72, 1)","contrastText":"#fff","grey":"#EDF1F9","greyDark":"#6F7883","greyBg":"#F8F9FF"},"error":{"light":"rgba(255, 122, 122, 1)","main":"rgba(245, 39, 24, 1)","dark":"rgba(201, 22, 22, 1)","contrastText":"#fff"},"text":{"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.65)","disabled":"rgba(24, 23, 23, 0.49)","hint":"rgba(0, 0, 0, 0.25)"}},
      typography: {
        fontFamily: 'Poppins',
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              "&.Mui-disabled": {
                background: "#CBD5E1",
                color: "#475569",
                boxShadow: "none",
                opacity: 1,
                cursor: "not-allowed",
              }
            }
          },
          variants: [
            {
              props: { variant: 'contained', color: 'primary' },
              style: () => ({
                color: '#000',
                background: "linear-gradient(45deg, #00C2FF 10%, #00E3AF 90%)",
                "&:hover": { color: '#000' },
                "&.Mui-disabled": {
                  background: "#CBD5E1",
                  color: "#475569",
                  boxShadow: "none",
                  opacity: 1,
                }
              }),
            },
            {
              props: { variant: 'outlined', color: 'primary' },
              style: () => ({
                color: '#000',
                border: "1px solid #00E3AF",
                "&:hover": { border: "1px solid #00E3AF", color: '#000', background: "transparent" }
              }),
            }
          ]
        }
      }}),
    [mode],
  );


  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
        <BrowserRouter>
        <MyApp />
         {/* <ChatBot/> */}
        </BrowserRouter>
        </Provider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
